import { Collapse } from 'antd'
import React from 'react'

import { SchemaCard } from 'src/Modules/DevPage/Components/SchemaCard'
import { CardsWrapper } from 'src/Modules/Home/Components/Card/CardWrapper'
import { DocumentCard } from 'src/Modules/Home/Components/Card/DocumentCard'
import { TabContentWrapper } from 'src/Modules/Home/Components/ContentWrappers/TabContentWrapper'
import { useGroupDocumentsBySchemaName } from 'src/Modules/Home/Containers/Content/Tabs/ReferencesPage/useDocumentReferences'
import { useDocument } from 'src/Modules/Home/Hooks/Document'
import CenteredCustomSpinner from 'src/Modules/Utilities/Components/Centering/CenteredCustomSpinner'
import CenteredEmpty from 'src/Modules/Utilities/Components/Centering/CenteredEmpty'
import { SuspenseAndBoundary } from 'src/Modules/Utilities/Components/SuspenseAndBoundary'

/**
 * A page to find all references for a document
 * @param props Props that determine the behavior of this component.
 * @returns A component with cards for all references.
 */
export default function DocumentReferencesPage(props: { documentId: number }) {
  const { data: document } = useDocument(props.documentId, { suspense: true })

  const referencingDocuments = useGroupDocumentsBySchemaName(
    document!.referencingDocuments
  )

  const referencedByDocuments = useGroupDocumentsBySchemaName(
    document!.referencedByDocuments
  )

  if (!document || !referencingDocuments || !referencedByDocuments)
    return <CenteredCustomSpinner />

  return (
    <TabContentWrapper>
      <Collapse
        defaultActiveKey={[
          'referencedByDocuments',
          'referencingDocuments',
          'referencingSchemas'
        ]}
      >
        <Collapse.Panel
          header='referencedByDocuments'
          key='referencedByDocuments'
        >
          {referencedByDocuments.length === 0 ? (
            <CenteredEmpty />
          ) : (
            <Collapse>
              {referencedByDocuments.map(([schemaName, documentIds]) => (
                <Collapse.Panel header={schemaName} key={schemaName}>
                  <SuspenseAndBoundary>
                    <CardsWrapper>
                      {documentIds.map((documentId) => (
                        <DocumentCard
                          documentId={documentId}
                          key={documentId}
                        />
                      ))}
                    </CardsWrapper>
                  </SuspenseAndBoundary>
                </Collapse.Panel>
              ))}
            </Collapse>
          )}
        </Collapse.Panel>
        <Collapse.Panel
          header='referencingDocuments'
          key='referencingDocuments'
        >
          {referencingDocuments.length === 0 ? (
            <CenteredEmpty />
          ) : (
            <Collapse>
              {referencingDocuments.map(([schemaName, documentIds]) => (
                <Collapse.Panel header={schemaName} key={schemaName}>
                  <SuspenseAndBoundary>
                    <CardsWrapper>
                      {documentIds.map((documentId) => (
                        <DocumentCard
                          documentId={documentId}
                          key={documentId}
                        />
                      ))}
                    </CardsWrapper>
                  </SuspenseAndBoundary>
                </Collapse.Panel>
              ))}
            </Collapse>
          )}
        </Collapse.Panel>
        <Collapse.Panel header='referencingSchemas' key='referencingSchemas'>
          {document.referencingSchemas.length === 0 ? (
            <CenteredEmpty />
          ) : (
            <SuspenseAndBoundary>
              <CardsWrapper>
                {document.referencingSchemas.map((schema) => (
                  <SchemaCard schemaId={schema} key={schema} />
                ))}
              </CardsWrapper>
            </SuspenseAndBoundary>
          )}
        </Collapse.Panel>
      </Collapse>
    </TabContentWrapper>
  )
}
